// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import PinterestLogoSvg from 'app/common/react/components/pincode/PinterestLogoSvg';
import type { ImageWithDominantColor } from 'app/packages/pinterest-flow-types/image';
import { Box, Card, Image, Mask, Touchable } from 'gestalt';

const GRID_MAX_HEIGHT = 328;
const PINCODE_HERO_IMAGE_CANDIDATE_SIZE = 85;

type Props = {
  getThumbnailImageSrcSet?: (string) => string,
  images: Array<ImageWithDominantColor>,
  onTouch: (number | 'logo') => void,
};

export default function PincodeHeroImagePicker({
  getThumbnailImageSrcSet,
  images,
  onTouch,
}: Props) {
  return (
    <Box
      display="flex"
      justifyContent="start"
      maxHeight={GRID_MAX_HEIGHT}
      overflow="auto"
      padding={1}
      wrap
    >
      {['logo'].concat(images).map((image, index) => (
        <Box key={image === 'logo' ? image : image.url} padding={1}>
          <Card>
            <Touchable
              onTouch={() => onTouch(image === 'logo' ? 'logo' : index - 1)}
              shape="rounded"
              fullWidth={false}
            >
              <Mask
                shape="circle"
                width={PINCODE_HERO_IMAGE_CANDIDATE_SIZE}
                height={PINCODE_HERO_IMAGE_CANDIDATE_SIZE}
              >
                {image === 'logo' ? (
                  <PinterestLogoSvg size={PINCODE_HERO_IMAGE_CANDIDATE_SIZE} />
                ) : (
                  <Image
                    alt={i18n._(
                      'Pincode Hero Image',
                      'accessibility label for the Pincode hero image',
                    )}
                    color={image.dominant_color || '#b5b5b5'}
                    fit="cover"
                    naturalHeight={image.height}
                    naturalWidth={image.width}
                    src={image.url}
                    srcSet={getThumbnailImageSrcSet && getThumbnailImageSrcSet(image.url)}
                  />
                )}
              </Mask>
            </Touchable>
          </Card>
        </Box>
      ))}
    </Box>
  );
}
